import { inject, Injectable } from '@angular/core';
import { ObservableQueryService } from './services';
import { FirebaseObservableService } from './firebase-observable.service';
import { Firestore } from '@angular/fire/firestore';
import { Auth } from '@angular/fire/auth';

@Injectable()
export class FirebaseObservableServiceFactory {
  private readonly firestore = inject(Firestore);
  private readonly auth = inject(Auth);

  constructor(private readonly observableQueryService: ObservableQueryService) {}

  createService<T>(collectionName: string): FirebaseObservableService<T> {
    return new FirebaseObservableService<T>(this.observableQueryService, collectionName, this.firestore, this.auth);
  }
}
